/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

import {connect} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {initStatusPage} from '@/businesses/autoProfileStatusBusiness';
import * as APPDATA from '@/constants/pcConstAppData';
import {eventBusObject} from '@/observers/eventBus';

import StatusDiagram from './reusable/StatusDiagram';
import {MANUAL_CONTROL, ManualControlEvent} from './reusable/StatusManualControl';
import StatusPageMenu from './reusable/StatusPageMenu';
// eslint-disable-next-line import/no-cycle
import StatusProfile from './reusable/StatusProfile';
// eslint-disable-next-line import/no-cycle
import StatusSensor from './reusable/StatusSensor';

import './StatusPage.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
}))
class StatusPage extends Component {
  constructor(props) {
    super(props);

    this._bus = eventBusObject();
  }

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(initStatusPage());
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.fontSize !== nextProps.fontSize) {
      return true;
    }
    if (this.props.isRemoteView !== nextProps.isRemoteView) {
      return true;
    }

    return false;
  }

  componentWillUnmount() {
    const {dispatch} = this.props;
    dispatch(setupActions.topButtonSecondaryProperties(undefined));
  }

  onClick = (e) => {
    switch (e.currentTarget.id) {
      case MANUAL_CONTROL:
        this._bus.publish(ManualControlEvent.EnableManualControl, '');
        break;
      case APPDATA.CYCLE_HISTORY:
        this.props.actionToCycleHistory();
        break;
      default:
        break;
    }
  };

  render() {
    const style = {
      constraint: {
        fontSize: this.props.fontSize,
      },
    };
    return (
      <div style={style.constraint}>
        <div className="row statusRow">
          <div className="col-md-8 col-lg-8 col-statusBox center">
            <div className="row col-md-12 statusBox">
              <div className="statusText">
                <StatusSensor />
              </div>
            </div>

            <div className="row col-md-12 profileBox ">
              <div className="profileText">
                <StatusProfile
                  isMobileView={false}
                  isRemoteView={this.props.isRemoteView}
                  onClickManualControl={this.onClick}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4 col-canvas ">
            <StatusDiagram />
          </div>
        </div>
        {/* <div className="row statusRow">
                    <div className="col-sm-9 col-md-9 col-lg-9 statusProgressBar">
                        <StatusProgressBar isRemoteView={this.props.isRemoteView} />
                    </div>
                </div> */}
        {!this.props.isRemoteView && <StatusPageMenu />}
      </div>
    );
  }
}

export default StatusPage;
